var map = {
	"./文件_Excel.png": "Mlq5",
	"./文件_MP3.png": "nnrx",
	"./文件_avi.png": "n7/v",
	"./文件_pdf.png": "7I/7",
	"./文件_ppt.png": "AEzW",
	"./文件_txt.png": "UgoW",
	"./文件_world.png": "LNWu",
	"./文件_zip.png": "SdJU",
	"./文件_未知.png": "kVIX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uha6";


//////////////////
// WEBPACK FOOTER
// ./packages/assets/file ^\.\/.*$
// module id = uha6
// module chunks = 0